/**
 * VIVI product-card media gallery � snap scroll + dots.
 * Only mounts on [data-vivi-card-gallery]; horizontal rails omit that attribute.
 */
(function () {
  if (window.ViviCardGallery) return;

  function updateDots(root) {
    var gallery = root.querySelector('[data-vivi-card-gallery-track]');
    var dots = root.querySelectorAll('[data-vivi-card-dot]');
    if (!gallery || !dots.length) return;

    var slideW = gallery.clientWidth || 1;
    var index = Math.round(gallery.scrollLeft / slideW);
    if (index < 0) index = 0;
    if (index > dots.length - 1) index = dots.length - 1;

    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === index);
    });
  }

  function bind(root) {
    if (root.dataset.viviGalleryBound === '1') return;
    var gallery = root.querySelector('[data-vivi-card-gallery-track]');
    if (!gallery) return;
    root.dataset.viviGalleryBound = '1';

    var ticking = false;
    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        updateDots(root);
        ticking = false;
      });
    };

    gallery.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(onScroll).observe(gallery);
    }
    updateDots(root);
  }

  function scan(scope) {
    (scope || document)
      .querySelectorAll('[data-vivi-card-gallery]:not([data-vivi-gallery-bound="1"])')
      .forEach(bind);
  }

  window.ViviCardGallery = { scan: scan, updateDots: updateDots };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target || document);
  });
})();
